import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "m16.6 10.88-1.42-1.42-4.24 4.25-2.12-2.13L7.4 13l3.54 3.54z"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M3 4v16h18V4H3zm16 14H5V8h14v10z"
}, "1")], 'DomainVerificationSharp');